import Fab from "./Fab";
import Icon from "./Icon";
import Normal from "./Normal";
import Primary from "./Primary";
import Secondary from "./Secondary";
import Toggle from "./Toggle";

export type { FabBtnProps } from "./Fab";
export type { IconBtnProps } from "./Icon";
export type { NormalBtnProps } from "./Normal";
export type { PrimaryBtnProps } from "./Primary";
export type { SecondaryBtnProps } from "./Secondary";
export type { ToggleBtnProps } from "./Toggle";

const Btn = {
  Primary,
  Secondary,
  Icon,
  Toggle,
  Normal,
  Fab,
};

export default Btn;

// 개별 import 지원
export { Primary, Secondary, Icon, Toggle, Normal, Fab };
